import { b as __assign } from '../_tslib-6fadb982.js';

var defaultConfig = {
    targetZIndex: 1,
    text: '高顿教育',
    fontSize: 14,
    fontFamily: '微软雅黑',
    density: [300, 200],
    color: '#999',
    opacity: 0.2,
    zIndex: 99999,
    rotate: 15,
};
var Watermark = /** @class */ (function () {
    function Watermark(config) {
        var _this = this;
        this._mark = document.createElement('div');
        this.observerConfig = { attributes: true };
        this.onNodeRemoved = function (event) {
            if (_this.removeTimer) {
                clearTimeout(_this.removeTimer);
                _this.removeTimer = 0;
            }
            // 正在移除还未移除，延时处理
            _this.removeTimer = setTimeout(function () {
                if (event.type === 'DOMNodeRemoved' && (event === null || event === void 0 ? void 0 : event.target)['id'] == 'watermark-mark') {
                    var doms = document.querySelectorAll('#watermark-mark');
                    if (!!doms && !!doms.length) {
                        doms.forEach(function (item) { return item.remove(); });
                    }
                    _this._mark && _this.insertMarkToDom();
                    clearTimeout(_this.removeTimer);
                    _this.removeTimer = 0;
                }
            }, 10);
        };
        this._ele = (config === null || config === void 0 ? void 0 : config.target) || document.querySelector('body');
        this._config = __assign(__assign({}, defaultConfig), config);
        this.install();
    }
    Watermark.prototype.install = function () {
        this._bg = this.drawTextAndCreateBg();
        this.setParentStyle();
        this.setMarkStyle();
        this.insertMarkToDom();
        this.addRemoveListion();
        this.addAttrChangeListion();
    };
    // 监听dom移除事件
    Watermark.prototype.addRemoveListion = function () {
        this._mark.addEventListener('DOMNodeRemoved', this.onNodeRemoved);
    };
    // 监听属性修改事件
    Watermark.prototype.addAttrChangeListion = function () {
        var _this = this;
        this.observer = new MutationObserver(function (mutationsList, observer) {
            for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
                var mutation = mutationsList_1[_i];
                if (mutation.type === 'attributes') {
                    // 停止观察，重写style会触发本事件
                    observer.disconnect();
                    // 重写style
                    _this.setMarkStyle();
                    // 再次监听
                    observer.observe(_this._mark, _this.observerConfig);
                }
            }
        });
        // 开始观察目标节点
        this.observer.observe(this._mark, this.observerConfig);
    };
    Watermark.prototype.insertMarkToDom = function () {
        var parentDom = this._ele.parentNode;
        parentDom.appendChild(this._mark);
    };
    Watermark.prototype.setParentStyle = function () {
        var targetZIndex = this._config.targetZIndex;
        this._ele.style.position = 'relative';
        this._ele.style.zIndex = targetZIndex.toString();
    };
    Watermark.prototype.setMarkStyle = function (mark) {
        if (mark === void 0) { mark = this._mark; }
        var _a = this._config, density = _a.density, zIndex = _a.zIndex, opacity = _a.opacity;
        mark.id = 'watermark-mark';
        mark.style.visibility = 'visible';
        mark.style.display = 'block';
        mark.style.position = 'absolute';
        mark.style.left = '0';
        mark.style.top = '0';
        mark.style.width = '100%';
        mark.style.height = '100%';
        mark.style.opacity = opacity.toString();
        mark.style.zIndex = zIndex.toString();
        mark.style.backgroundColor = 'transparent';
        mark.style.backgroundSize = density[0] + "px " + density[1] + "px";
        mark.style.pointerEvents = 'none';
        mark.style.backgroundRepeat = 'repeat';
        mark.style.backgroundImage = "url(" + this._bg + ")";
    };
    Watermark.prototype.drawTextAndCreateBg = function () {
        var _a;
        var _b = this._config, fontSize = _b.fontSize, fontFamily = _b.fontFamily, text = _b.text, color = _b.color, density = _b.density, rotate = _b.rotate;
        this._canvas = document.createElement('canvas');
        this._canvas.width = density[0];
        this._canvas.height = density[1];
        this._canvas.style.position = 'absolute';
        this._canvas.style.top = '150px';
        this._canvas.style.left = '250px';
        var ctx = this._canvas.getContext('2d');
        ctx.translate(density[0] / 2, density[1] / 2);
        ctx.rotate((Math.PI / 180) * -rotate);
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        ctx.font = "normal normal " + fontSize + "px " + fontFamily;
        ctx.fillStyle = color;
        ctx.fillText(text || '', 0, 0);
        return (_a = this._canvas) === null || _a === void 0 ? void 0 : _a.toDataURL('image/png');
    };
    Watermark.prototype.destory = function () {
        this._mark.removeEventListener('DOMNodeRemoved', this.onNodeRemoved);
        this._mark.remove();
        this._canvas = undefined;
        this._bg = '';
        this.observer = undefined;
        return null;
    };
    return Watermark;
}());

export default Watermark;
